export function formatDate(date: Date) {
  if (!(date instanceof Date)) {
    throw new Error('Input should be a Date object');
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

export const formatDateIntoStringOfNumbers = (date: Date) => date.toISOString().slice(0, -1)
.split('-')
.reverse()
.join('')
.replace(/\D/g, '');
